import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Agent } from "@/types/agent";

interface AgentSelectProps {
  agents: Agent[];
  selectedAgentId: string;
  onAgentSelect: (value: string) => void;
}

export const AgentSelect = ({ agents, selectedAgentId, onAgentSelect }: AgentSelectProps) => {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Selecionar Agente</label>
      <Select value={selectedAgentId} onValueChange={onAgentSelect}>
        <SelectTrigger>
          <SelectValue placeholder="Selecione um agente" />
        </SelectTrigger>
        <SelectContent>
          {agents.map((agent) => (
            <SelectItem key={agent.id} value={agent.id.toString()}>
              {agent.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};